import React, { createContext, useContext, useState } from 'react';

const graphContext = createContext();

export const useGraphContext = () => {
  return useContext(graphContext);
};

export const GraphProvider = ({ children }) => {
  const [pointsVisible, setPointsVisible] = useState(['All']);

  const togglePointsVisibility = (shouldShow) => {
    setPointsVisible(shouldShow);
  };

  return (
    <graphContext.Provider value={{ pointsVisible, togglePointsVisibility }}>
      {children}
    </graphContext.Provider>
  );
};
